const COLORS = ['#0F2A4A','#7CB342','#1E3A5F','#4FA0E8','#F3A845','#7C5CD3','#E5645A','#5d9933']

function colorFor(s = '') {
  return COLORS[(s.charCodeAt(0) + s.length) % COLORS.length]
}

function initials(n = '') {
  return n.split(' ').slice(0, 2).map(w => w[0] || '').join('').toUpperCase()
}

interface DashAvatarProps {
  name: string
  size?: number
}

export default function DashAvatar({ name, size = 32 }: DashAvatarProps) {
  return (
    <div
      className="avatar"
      style={{
        width: size, height: size,
        background: colorFor(name),
        fontSize: size * 0.34,
      }}
    >
      {initials(name)}
    </div>
  )
}
